import { RadioGroup } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceRadioGroup",
  //extends: RadioGroup,
  mixins: [RadioGroup, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    groupDisabled() {
      return this.disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
